
// 리셋링크 메일발송용 폼. iframe으로 api의 index22.blade.php를 보여주고 있다.

import { ajaxor4 } from '../../common/basic';


export default props=>{

    const jsx = (
        <div className="fallback fallback3" style={{ display: props.display }} onClick={props.hide} >
            <style jsx>{`
.this-content{
    width: 460px;

    padding: 45px 60px;
}

.x{
    float:right;
    margin: -20px -20px 0 0;
}

.logo{
    text-align:center;
}

.title{
    font-size: 16px;
    text-align: center;
    color: #343a40;
}

.button45{
    width: 100%;
    height: 45px;
    text-align: center;
    padding-top: 12px;
    margin: 10px 0;
    vertical-align:middle;
}

.button45 img{
  vertical-align:middle;
}

.button1{
    background-color: #325a9f;
    font-size: 14px;
    color: white;
}

.button2{
    background-color: #feea0e;
    font-size: 14px;
    color: #343a40;
}

.or{
  text-align: center;
}

.label1{} {
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: -0.25px;
  color: #868e96;
}

.input1{
    width: 100%;
    /* height: 24px; */
    font-size: 14px;
    color: #adb5bd;
    border: none;
    padding-top: 15px;
}

.comment1{
  font-size: 12px;
  color: #55d5ce;
}
.sentence1{
  font-size: 14px;
  color: #343a40;
  text-align:right;

  position: absolute;
  top: 280px;
  right: 80px;
  background-color: white;
}

iframe {
    width: 100%;
    height: 110px;
    border: 0;
}

    
.button3{
    background-color: #212529;
    color: white;
    font-size: 14px;
}

.sentence2{
    font-size: 14px;
    color: #343a40;
    text-align:center;
    width: 440px;
    margin-left: -50px;
}


@media all and (max-width:606px) {
    .fallback .content-margin.vertically-middle {
        margin: auto;
        padding: 50px 20px;
        max-width: 80%;
        display: inline-block;
        text-align: left;
    }

    div.content-margin
    {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        transform: none;
        height: auto;
        width: auto;
    }


    .this-content{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: white;
        padding: 16px 24px;
        box-sizing: border-box;
        width: auto;
    }


    .sentence2{
        width: auto;
        margin: auto;
        padding: 0;
    }

    .x2{
        float: right;
        margin: 0;
    }

    .logo{
        padding: 40px 0 0 0;
    }
}


`}</style>
            <div className="content-margin vertically-middle">
                <div className="content-body" onClick={(e) => { e.stopPropagation() }}>
                    <div className="this-content">

        <div className="x dnom"><a onClick={props.hide}><img src="/assets/images2/x_dark.svg" /></a></div>
        <div className="x2 dibom" onClick={props.hide}><img src="/assets/images-m/x_2.svg" /></div>
        <div className="">&nbsp;</div>
        <div className="logo"><img src="/assets/images/logo-camscon.svg" /></div>
        <div className="">&nbsp;</div>
        <div className="title">비밀번호를 잊으셨거나, 변경하길 원하시나요?</div>
        <div className="">&nbsp;</div>
        <div className="">&nbsp;</div>


        <iframe src="https://api.camscon.kr/reset-password22" />
        {/* <iframe src="http://localhost:8000/reset-password22" /> */}
        {/* <iframe src="/popup/member/ResetPassword2_iframe" /> */}

        <a onClick={props.setLogin}>
            <div className="sentence1 display-none">다시한번 로그인해보시겠어요?</div>
        </a>

        <div className="">&nbsp;</div>
        <div className="sentence2">입력하신 메일로 1시간 동안 유효한 비밀번호 재설정 링크를 발송해드립니다.
    <br /> (카카오로 가입한 회원은 재설정 불가)</div>
        <div className="">&nbsp;</div>


                    </div>
                </div>
            </div>

    </div>);

    return (jsx);

}
